export const leglerBenboughContent = (
  <>
    <div className="prose dark:prose-invert max-w-none">
      <p>
        The Legler Benbough Foundation approached Township to help document and
        share their unique approach to &ldquo;Grantee Relationship
        Philanthropy&rdquo; developed over 20 years of community impact. We
        created an interactive digital experience that makes their lessons
        learned accessible to other foundations and philanthropic organizations.
      </p>
    </div>
  </>
);
